export const getPrimeiroNome = (nomeCompleto: string | undefined) => {
     if (!nomeCompleto) return '';
     return nomeCompleto.split(' ')[0];
};
